import React, { useState } from 'react';
import { TextField, Button, Grid, Typography, Container, Box, InputAdornment, IconButton, Link } from '@mui/material';
import { handleSpaces, getErrorMessage } from '../utils/helper';
import axios from 'axios';
import { danger } from '../utils/message-box';
import { useLocation, useNavigate } from "react-router-dom";
import VipFormerLogo from '../assets/images/logo.png';
import axiosInstance from '../Services/axiosInstance.js';
import { syncUserFromToken, getPostLoginPath } from '../utils/auth.js';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const SignIn = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [nameError, setNameError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [openSnackbar, setOpenSnakbar] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        if (!username || !password) {
            setError('Please fill in all fields.');
            danger('Please fill in all fields.');
            return false;
        }
        if (nameError || passwordError) {
            return false;
        }
        
        setError('');
        const email = username;
        localStorage.removeItem('access-token');
        localStorage.removeItem('refresh-token');

        axiosInstance.post('/api/v1/auth/signin', { email, password })
        .then((res) => {
            setError('');
            const payload = syncUserFromToken(res.data.accessToken, res.data.refreshToken);
            const target = getPostLoginPath(payload);
            navigate(target);
            window.location.href = target;
        }).catch((error) => {
            const msg = getErrorMessage(error, 'Sign in failed. Please check your credentials.');
            setError(msg);
            window.setTimeout(() => danger(msg), 0);
        });
        
        return false;
    };
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
      };
    
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    return (
        <>
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                {/* <Typography component="h1" variant="h5">
                    Sign In
                </Typography> */}
                <Grid className='ml-40 text-center'>
                    <Typography>
                        <img src={VipFormerLogo} style={{ width: "50%" }}></img>
                    </Typography>
              {/* <Typography
                variant="h5"
                className="gray9 f-24 font-weight-600 signin-title"
              >
                Welcome back!
              </Typography> */}
              <Typography className="gray7 f-16 font-weight-400 mt-20">
                Please fill your login details in the below fields
              </Typography>
            </Grid>
                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 3 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} className='login-padding'>
                            <Typography className="gray8 font-weight-500 f-14">Email or mobile number</Typography>
                            <TextField
                                required
                                type="text"
                                className={`form-control input-group mb-0 inputcontrasts${nameError ? "is-invalid" : ""
                                    }`}
                                margin="normal"
                                placeholder="Enter email or 10-digit mobile number"
                                onKeyPress={handleSpaces}
                                value={username}
                                onChange={(e) => {
                                    setUsername(e.target.value);
                                    if (e.target.value?.length > 128) {
                                        setNameError('Exceeded maximum character length of 128');
                                    } else {
                                        setNameError('');
                                    }
                                }}
                            />
                            <span className="danger-color error-msg">
                                {" "}
                                {nameError}
                            </span>
                        </Grid>
                        <Grid item xs={12} className='login-padding'>
                            <Typography className="gray8 font-weight-500 f-14">Password</Typography>
                            <TextField
                                required
                                type={showPassword ? "text" : "password"}
                                className={`form-control sign-field input-group mb-0 inputcontrasts${passwordError ? "is-invalid" : ""
                                    }`}
                                margin="normal"
                                placeholder="Enter password"
                                onKeyPress={handleSpaces}
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    if (e.target.value?.length > 128) {
                                        setPasswordError('Exceeded maximum character length of 128');
                                    } else {
                                        setPasswordError('');
                                    }
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                        <IconButton
                                            aria-label="show-hide-password"
                                            onClick={handleClickShowPassword}
                                            onKeyPress={handleClickShowPassword}
                                            onMouseDown={handleMouseDownPassword}
                                            sx={{
                                            "& .MuiTouchRipple-root": { position: "static" },
                                            }}
                                            tabIndex={0}
                                        >
                                            {showPassword ? (
                                            <Visibility
                                                aria-label="Visibility icon"
                                                tabIndex={-1}
                                            />
                                            ) : (
                                            <VisibilityOffIcon
                                                aria-label="Visibilityoff icon"
                                                tabIndex={-1}
                                            />
                                            )}
                                        </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <span className="danger-color error-msg">
                                {" "}
                                {passwordError}
                            </span>
                        </Grid>
                    </Grid>
                    {error ? (
                        <Typography className="danger-color error-msg" sx={{ mt: 1, textAlign: 'center' }}>
                            {error}
                        </Typography>
                    ) : null}
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className='btn primary-button login-button'
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Sign In
                    </Button>
                    {/* <Grid container justifyContent="center">
                        <Grid item>
                            <Link
                                component="button"
                                variant="body2"
                                onClick={() => navigate('/resetpassword')}
                                className="link-color f-14 font-weight-500"
                                sx={{ textDecoration: 'none' }}
                            >
                                Reset Password
                            </Link>
                        </Grid>
                    </Grid> */}
                   {/* <Grid container justifyContent="center">
                        <Grid item>
                            <Typography className="gray7 f-14 font-weight-400 text-center mt-10">
                                Don't have an account?{' '}
                                <Link 
                                    component="button"
                                    variant="body2"
                                    onClick={() => navigate('/signup')}
                                    className="link-color f-14 font-weight-500"
                                    sx={{ textDecoration: 'none' }}
                                >
                                    Create Account
                                </Link>
                            </Typography>
                        </Grid>
                    </Grid> */}
                </Box>
            </Box>
        </Container>
        {/* ToastContainer is initialized in index.js */}
        </>
    );
};

export default SignIn;
